// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","loader":"Loader_loader__+lRPl","load6":"Loader_load6__7wSf-","round":"Loader_round__jWaY2"};